import { render, staticRenderFns } from "./building-event.vue?vue&type=template&id=f311b8f8&"
import script from "./building-event.vue?vue&type=script&lang=js&"
export * from "./building-event.vue?vue&type=script&lang=js&"
import style0 from "./building-event.vue?vue&type=style&index=0&id=f311b8f8&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports